import React from 'react'
import Landing from '../routes/landings/Bathroom'

const Bathroom = () => {
  return <Landing />
}

export default Bathroom
